import './styles.css';

import React from 'react';

import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Paper, Grid } from '@material-ui/core';

import FormCartao from './formCartao';
import { schema } from './schema';

import { useStyles } from '../baseStyle';

function PagamentoComCartao(props) {
  const classStyles = useStyles(props);

  const methods = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classStyles.grid}
    >
      <Paper elevation={10} className={classStyles.root}>
        <div className={classStyles.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classStyles.logo}
          />
        </div>
        <FormProvider {...methods}>
          <FormCartao state={props.location.state} />
        </FormProvider>
      </Paper>
    </Grid>
  );
}

export default PagamentoComCartao;
